import { render, staticRenderFns } from "./MiniCart.vue?vue&type=template&id=4b01fbd6&"
import script from "./MiniCart.vue?vue&type=script&lang=js&"
export * from "./MiniCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports